/*
 * @Author       : LQ
 * @Description  :
 * @version      : 1.0
 * @Date         : 2021-08-20 16:44:21
 * @LastAuthor   : LQ
 * @lastTime     : 2021-08-20 17:07:33
 * @FilePath     : /u-view2.0/uview-ui/libs/config/props/section.js
 */
export default {
    // u-section组件
    section: {
        title: '',
        subTitle: '更多',
        right: true,
        fontSize: 15,
        bold: true,
        color: '#303133',
        subColor: '#909399',
        showLine: true,
        lineColor: '',
        arrow: true
    }
}
